import FindOrganization from './FindOrganization';

export default FindOrganization;



// WEBPACK FOOTER //
// ./src/pages/Registration/subComponents/FindOrganization/index.jsx